<mat-slide-toggle
  (change)="toggleAll($event)"
  [(ngModel)]="allSelected"
  [disabled]="disabled"
  color="primary"
  name="all_communication_types"
>
  {{selectAllLabel}}
</mat-slide-toggle>
<fieldset class="communication-preferences" [class.disabled]="disabled">
  <label *ngFor="let type of availableEntityMemberCommunicationTypes">
    <mat-checkbox
      (change)="toggleOption($event)"
      [disabled]="disabled"
      [ngModel]="entityMemberCommunicationTypeSelections.get(type.value)"
      (ngModelChange)="entityMemberCommunicationTypeSelections.set(type.value, $event)"
      [name]="type.value"
    ></mat-checkbox>
    <span class="checkbox-label-text">{{entityMemberCommunicationTypeLabels[type.value]}}</span>
  </label>
</fieldset>
